module.exports = __webpack_public_path__ + "img/warning.bfa9d318.png";